<div class="app-count">
  <span>{{ 'search.results' | translate }}: {{ browseService.getResultIndexFrom() }} - {{ browseService.getResultIndexTo() }}</span>
  <span class="app-slash">/</span> 
  <span class="app-all">{{browseService.getNumberOfResults()}}</span>
</div>